import io from 'socket.io-client';
import actions from '../store/actions';
import store from "../store/store";

const socketUrl = process.env.REACT_APP_BASE_URL_SOCKET;

let socketConnection = io.connect(socketUrl);

socketConnection.on("connect", () => {
    console.log("socket connected successfully.");
    // Access the socket ID
    const socketId = socketConnection.id;
    console.log("Socket ID:", socketId);
    const profile = JSON.parse(localStorage.getItem("profile"));
    if (profile?._id) {
        socketConnection.emit("login", profile?._id);
    }
});

socketConnection.on("disconnect", () => {
    console.log("its disconnected");
});

// *****************************************************************************

socketConnection.on("systemMessage", (data) => {
    console.log("systemMessage", data);
    store.dispatch(actions.updateBlockedAppStatus({
        blocked: true,
        message: data?.message || "You have login some where else reload to use here"
    }));
});


export default socketConnection